// Ported from app/assets/javascripts/application/recent_tasks.js
// (The recent task pill rail was retired when the work-panel Recent view replaced
//  it; this binding stays for any remaining `#favorite_tasks .item` shortcut.)
//
// Delegated through document so it survives Turbo navigations.

document.addEventListener("click", (event) => {
  const target = event.target as HTMLElement
  if (target.nodeName !== "DIV") return
  const item = target.closest("#favorite_tasks .item")
  if (!item) return
  item.querySelector<HTMLElement>("a.action")?.click()
})
